export const emailsForInvitation = {
  'en': {
    'subject': 'Welcome to the CIATTI Extranet: Access Your Contracts, List Items, and Indicate Purchase Needs',
    'body': `Dear [name],

I hope this email finds you well. I am pleased to announce that you have been granted access to the CIATTI Extranet. Our platform offers a range of features designed to simplify your transactions and improve your business experience with us.

Through the CIATTI Extranet, you will be able to:

1. Access your contracts: All your contracts with CIATTI are stored safely on our platform. You can view, download, and track the status of your contracts at your convenience.

2. List your items for sale: Listing items to sell has never been easier. Our platform allows you to upload details about your items, manage listings, and monitor their status in real-time.

3. Indicate your purchase needs: You can directly convey your buying requirements to us through the Extranet. This will allow us to better understand your needs and offer the most suitable solutions.

To get started:

1. Visit [url]
2. Enter your username: [email]
3. Create a password:

And that's done.
You will be able to browse your items, buy specs and S&P Agreements.

Should you have any questions or encounter any issues, please feel free to contact our dedicated customer support team at support@ciatti.com.

We look forward to seeing you on the CIATTI Extranet.

Best regards,

The CIATTI Team`
  },
  'fr': {
    'subject': `Bienvenue sur l'Extranet de CIATTI : Accédez à Vos Contrats, Listez Vos Articles, et Indiquez Vos Besoins d'Achat`,
    body: `Cher(e) [name],

J'espère que ce courriel vous trouve en bonne santé. Je suis ravi de vous annoncer que vous avez désormais accès à l'Extranet de CIATTI. Notre plateforme offre une gamme de fonctionnalités conçues pour simplifier vos transactions et améliorer votre expérience commerciale avec nous.

Via l'Extranet de CIATTI, vous pourrez :

1. Accéder à vos contrats : Tous vos contrats avec CIATTI sont stockés en toute sécurité sur notre plateforme. Vous pouvez les consulter, les télécharger et suivre leur statut à votre convenance.

2. Lister vos articles à vendre : La mise en vente d'articles n'a jamais été aussi simple. Notre plateforme vous permet de télécharger les détails sur vos articles, de gérer les listes et de suivre leur statut en temps réel.

3. Indiquer vos besoins d'achat : Vous pouvez nous transmettre directement vos besoins d'achat via l'Extranet. Cela nous permettra de mieux comprendre vos besoins et de vous proposer les solutions les plus adaptées.

Pour commencer :

1. Visitez [url]
2. Entrez votre nom d'utilisateur : [email]
3. Créez un mot de passe :

Et voilà, c'est fait.
Vous pourrez consulter vos articles, acheter des spécifications et des accords S&P.

Si vous avez des questions ou rencontrez des problèmes, n'hésitez pas à contacter notre équipe de support client dédiée à support@ciatti.com.

Nous avons hâte de vous voir sur l'Extranet de CIATTI.

Cordialement,

L'équipe CIATTI`
  },
  'es': {
    'subject': 'Bienvenido a la Extranet de CIATTI: Accede a Tus Contratos, Enumera Tus Artículos, e Indica Tus Necesidades de Compra',
    'body': `Estimado/a [name],

Espero que este correo electrónico te encuentre bien. Me complace anunciar que has obtenido acceso a la Extranet de CIATTI. Nuestra plataforma ofrece una serie de características diseñadas para simplificar tus transacciones y mejorar tu experiencia comercial con nosotros.

A través de la Extranet de CIATTI, podrás:

1. Acceder a tus contratos: Todos tus contratos con CIATTI están almacenados de manera segura en nuestra plataforma. Puedes ver, descargar y hacer seguimiento del estado de tus contratos a tu conveniencia.

2. Enumerar tus artículos para la venta: Enumerar artículos para vender nunca ha sido tan fácil. Nuestra plataforma te permite subir detalles sobre tus artículos, gestionar listados y monitorear su estado en tiempo real.

3. Indicar tus necesidades de compra: Puedes transmitirnos directamente tus requerimientos de compra a través de la Extranet. Esto nos permitirá entender mejor tus necesidades y ofrecerte las soluciones más adecuadas.

Para comenzar:

1. Visita [url]
2. Ingresa tu nombre de usuario: [email]
3. Crea una contraseña:

Y eso es todo.
Podrás explorar tus artículos, comprar especificaciones y acuerdos S&P.

Si tienes alguna pregunta o encuentras algún problema, no dudes en ponerte en contacto con nuestro dedicado equipo de atención al cliente en support@ciatti.com.

Esperamos verte pronto en la Extranet de CIATTI.

Un cordial saludo,

El Equipo de CIATTI`
  },
}
